import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { AppUserListComponent } from './app-user-list/app-user-list.component';
import { AppointmentListComponent } from './appointment-list/appointment-list.component';
import { GateListComponent } from './gate-list/gate-list.component';
import { UnitListComponent } from './unit-list/unit-list.component';
import { HttpServiceService } from './common/service/http-service.service';
import { ServiceLocatorService } from './common/service/service-locator.service';
import { EndpointServiceService } from './common/service/endpoint-service.service';
import { DataValidatorService } from './common/service/data-validator.service';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { LoginComponent } from './common/login/login.component';
import { MenuComponent } from './menu/menu.component';
import { ErrorComponent } from './common/apperror.component';
import { CookieService } from 'ngx-cookie-service';
import { WelcomePageComponent } from './welcome-page/welcome-page.component';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { AccessLogListComponent } from './access-log-list/access-log-list.component';
import { EmployeeMangementListComponent } from './employee-mangement-list/employee-mangement-list.component';
import { VisitorMangementListComponent } from './visitor-mangement-list/visitor-mangement-list.component';
import { AttendanceListComponent } from './attendance-list/attendance-list.component';
import { ListHeaderComponent } from './common/list-header/list-header.component';
import { ListBodyComponent } from './common/list-body/list-body.component';
import { DashboardComponent } from './common/dashboard/dashboard.component';
import { AppInfoComponent } from './common/app-info/app-info.component';

import { SignupComponent } from './common/signup/signup.component';
import { FormErrorComponent } from './common/form-error';
import { FormInputComponent } from './common/form-input';
import { EventService } from './common/service/event.service';
import { DepartmentComponent } from './department/department.component';
import { RouterModule, Routes } from '@angular/router';
import { WorkingHoursComponent } from './working-hours/working-hours.component';
import { MobileLocationComponent } from './mobile-location/mobile-location.component';
import { MobileContactComponent } from './mobile-contact/mobile-contact.component';
import { CallLogsComponent } from './call-logs/call-logs.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { MobileGalleryComponent } from './mobile-gallery/mobile-gallery.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MyProfileComponent } from './common/my-profile/my-profile.component';
import { ShiftBasedComponent } from './shift-based/shift-based.component';
import { MessageListComponent } from './message-list/message-list.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { EmployeeQrcodeListComponent } from './employee-qrcode-list/employee-qrcode-list.component';
import { AppConfigComponent } from './common/app-config/app-config.component';
import { ApplicationInfoComponent } from './common/application-info/application-info.component';
import { ErrorLogComponent } from './common/error-log/error-log.component';
import { EventListComponent } from './event-list/event-list.component';
import { EventLogListComponent } from './event-log-list/event-log-list.component';

const routes: Routes = [
];

@NgModule({
  declarations: [
    AppComponent,
    SignupComponent,
    LoginComponent,
    AppInfoComponent,
    AppConfigComponent,
    ApplicationInfoComponent,
    ErrorLogComponent,
    MyProfileComponent,
    DashboardComponent,
    AppUserListComponent,
    AppointmentListComponent,
    MyProfileComponent,
    GateListComponent,
    UnitListComponent,
    MenuComponent,
    SignupComponent,
    ErrorComponent,
    FormErrorComponent,
    FormInputComponent,
    WelcomePageComponent,
    ForgetPasswordComponent,
    AccessLogListComponent,
    EmployeeMangementListComponent,
    VisitorMangementListComponent,
    AttendanceListComponent,
    ListHeaderComponent,
    DepartmentComponent,
    WorkingHoursComponent,
    MobileLocationComponent,
    MobileContactComponent,
    CallLogsComponent,
    MobileGalleryComponent,
    ShiftBasedComponent,
    MessageListComponent,
    ChangePasswordComponent,
    EmployeeQrcodeListComponent,
    EventListComponent,
    EventLogListComponent,
    
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    RouterModule.forRoot(routes, { useHash: true }),
    BsDatepickerModule.forRoot(),
    BrowserAnimationsModule,
  
    
   
  ],
  providers: [
    CookieService,
    HttpServiceService,
    ServiceLocatorService,
    EndpointServiceService,
    DataValidatorService,
    EventService
    
  ],
  bootstrap: [AppComponent]

})
export class AppModule { }
